import React from 'react'
import { Row, H1, MarginBox, LabelSpacer, Button, DialogOverlay, useOverlay } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import PlaceReportsBreadCrumbs from './PlaceReportsBreadCrumbs'
import PlaceReportsSearch from './PlaceReportsSearch'
import PlaceReportsGuide from './PlaceReportsGuide'

export default function PlaceReportsHeader() {
  const [t] = useTranslation()
  const overlay = useOverlay()

  return (
    <MarginBox marginX="nano" marginY="nano">
      <Row alignItemsY="middle" wrap>
        <Row growX noShrinkX>
          <div growX noShrinkX>
            <H1 size="H3">{t('place-reports.reports-header.header', 'Place Reports')}</H1>
            <PlaceReportsBreadCrumbs />
          </div>
        </Row>
        <Row alignItemsY="middle" gutters="xs">
          <Button onClick={overlay.handleClick} title="Detailed user guide for place report sections and defaults">
            {t('place-reports.guide.button', 'User Guide')}
          </Button>
          <div style={{ width: 400 }}>
            <LabelSpacer />
            <PlaceReportsSearch />
          </div>
        </Row>
      </Row>

      <DialogOverlay title={t('place-reports.guide.title', 'Place Reports User Guide')} size="xl" {...overlay}>
        <PlaceReportsGuide />
      </DialogOverlay>
    </MarginBox>
  )
}
